import type { Editor } from "grapesjs";
import { useEffect } from "react";

export function useLoadEditorContent(
    editor: Editor | null,
    payload?: { html?: string; css?: string }
) {
    useEffect(() => {
        if (!editor) return;
        if (!payload) return;

        const html = payload.html ?? "";
        const css = payload.css ?? "";

        editor.DomComponents.clear();
        editor.CssComposer.clear();

        editor.setComponents(html);
        editor.setStyle(css);

        editor.render();
    }, [editor, payload?.html, payload?.css]);
}